import { React, useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import '../styles/Budget.css';
import NavBar from './NavBar';
import { get_budget } from '../api/budget_api';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';

const CATEGORIES = ["סיוע ורווחה", "הכנסת כלה", "כולל", 'שכ"ל']
const COLORS = ['#EF5DA8', '#7879F1', '#9b9bd6', '#e3c3fd', '#c756a1'];

const Budget = () => {
    const [budget, setBudget] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [selectedSummary, setSelectedSummary] = useState("monthly");

    useEffect(() => {
        const fetchBudget = async () => {
            try {
                const budget_data = await get_budget(CATEGORIES);
                console.log("budget_data", budget_data);
                const formattedData = budget_data.map(item => ({
                    name: item.category_group,
                    totalAmount: parseFloat(item.totalAmount),
                }));
                setBudget(formattedData);
            } catch (err) {
                console.error(err);
                setError('טעינת נתוני התקציב נכשלה');
            }
        };
        fetchBudget();
    }, []);

    const renderCustomizedLabel = ({ cx, cy, midAngle, outerRadius, index }) => {
        const RADIAN = Math.PI / 180;
        const startRadius = outerRadius;
        const endRadius = outerRadius + 30;
        const sx = cx + startRadius * Math.cos(-midAngle * RADIAN);
        const sy = cy + startRadius * Math.sin(-midAngle * RADIAN);
        const ex = cx + endRadius * Math.cos(-midAngle * RADIAN);
        const ey = cy + endRadius * Math.sin(-midAngle * RADIAN);
        const isRightSide = ex > cx;
        return (
            <g>
                <line x1={sx} y1={sy} x2={ex} y2={ey} stroke={COLORS[index % COLORS.length]} strokeWidth={1.5}
                />
                <text
                    x={ex}
                    y={ey - 10}
                    textAnchor="middle"
                    dominantBaseline="central"
                    fontSize={12}
                    fontWeight="bold"
                    fill="#333"
                    transform={`translate(${isRightSide ? 10 : -10}, 10)`}
                >
                    {`${budget[index].name}: ${budget[index].totalAmount.toLocaleString()}`}
                </text>
            </g>
        );
    };

    const handleSummaryChange = async (event) => {
        const newSummary = event.target.value;
        setSelectedSummary(newSummary);
        try {
            const data = await get_budget(CATEGORIES, newSummary);
            const formatted = data.map(item => ({
                name: item.category_group,
                totalAmount: parseFloat(item.totalAmount),
            }));
            setBudget(formatted);
            setError(null);
        } catch (err) {
            console.error(err);
            setError('טעינת נתוני התקציב נכשלה');
        }
    };

    return (
        <>
            {/* <NavBar /> */}
            <div className="top-buttons-container" style={{ marginBottom: "1.25rem" }}>
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>
            <div className="budget-container" style={{ marginTop: "5rem" }}>
                <h2 className="budget-title">נתוני תקציב</h2>
                <div className="summary-select-container">
                    <label htmlFor="summary-select">בחר סוג סיכום:</label>
                    <select
                        id="summary-select"
                        className="summary-select"
                        value={selectedSummary}
                        onChange={handleSummaryChange}
                    >
                        <option value="monthly">סיכום חודשי</option>
                        <option value="quarterly">סיכום רבעוני</option>
                        <option value="yearly">סיכום שנתי</option>
                    </select>
                </div>
                {(error || budget.length === 0) ? (
                    <p>{error || 'לא נמצאו נתונים להצגה עבור טווח הזמן שנבחר.'}</p>
                ) : (
                    <ResponsiveContainer width="100%" height={400}>
                        <PieChart>
                            <Pie
                                data={budget}
                                dataKey="totalAmount"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                outerRadius={120}
                                fill="#8884d8"
                                labelLine={false}
                                label={renderCustomizedLabel}
                            >
                                {budget.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend verticalAlign="bottom" height={30} />
                        </PieChart>
                    </ResponsiveContainer>)}
            </div>
            {/* <Footer /> */}
        </>
    );
};

export default Budget;